<template>

    <small class="mei-formset-accordion-label muted block ion-margin-top">Quantità</small>
    <div class="mei-formset-accordion-segment ion-margin-top-half flex items-center">
        <ion-segment :value="quantity" @ionChange="$emit('update:quantity', $event.target.value)">
            <ion-segment-button tabindex="-1" :value="OutdoorTrapAuditQuantity.high"
                                style="--margin-top: 0; --margin-bottom: 0">
                <ion-label>A</ion-label>
            </ion-segment-button>
            <ion-segment-button tabindex="-1" :value="OutdoorTrapAuditQuantity.medium"
                                style="--margin-top: 0; --margin-bottom: 0">
                <ion-label>M</ion-label>
            </ion-segment-button>
            <ion-segment-button tabindex="-1" :value="OutdoorTrapAuditQuantity.low"
                                style="--margin-top: 0; --margin-bottom: 0">
                <ion-label>B</ion-label>
            </ion-segment-button>
            <ion-segment-button tabindex="-1" :value="OutdoorTrapAuditQuantity.nil"
                                style="--margin-top: 0; --margin-bottom: 0">
                <ion-label>N</ion-label>
            </ion-segment-button>
        </ion-segment>
    </div>
    <div class="ion-margin-top" style="text-align: right">
        <ion-checkbox @ionChange="$emit('update:damaged', $event.target.checked)" :checked="damaged">Danneggiata</ion-checkbox>
    </div>
    <div class="mei-formset-accordion-field-group ion-margin-top-half">
        <ion-textarea class="mei-input mei-note-input" tabindex="-1"
                      :value="note" @input="$emit('update:note', $event.target.value)" label="Note"
                      label-placement="stacked"></ion-textarea>
    </div>
</template>

<script setup lang="ts">
import {OutdoorTrapAuditQuantity} from "@/types/audit";
import {IonCheckbox, IonLabel, IonSegment, IonSegmentButton, IonTextarea} from "@ionic/vue";
import {PropType} from "vue";

defineProps({
    note: {
        type: String,
        required: true,
    },
    quantity: {
        type: String as PropType<OutdoorTrapAuditQuantity>,
        required: true,
    },
    damaged: {
        type: Boolean,
        required: true,
    }
});
defineEmits(['update:note', 'update:quantity', 'update:damaged']);

</script>

<style scoped>

</style>
